module.exports = __webpack_public_path__ + "img/landing_product_thumbnail-600x450.888f0d93.jpg";